class UpDownNumberInput {
  constructor(DOMelement) {
    try {
      this.el = DOMelement;
      this.input = this.el.querySelector(".sd-up-down-number-input__input");
      this.decrement = this.el.querySelector(".decrement");
      this.increment = this.el.querySelector(".increment");
      
      this.setValue = this.setValue.bind(this);
      if(!this.increment.classList.contains("clickActive")){
        this.increment.addEventListener("click", () => this.setValue(true));      
        this.increment.classList.add("clickActive")
      }
      if(!this.decrement.classList.contains("clickActive")){
        this.decrement.addEventListener("click", () => this.setValue(false));
        this.decrement.classList.add("clickActive")
      }
    } catch (error) {
      console.log(error);
    }    
  }

  setValue(increment) {
    if (increment) {
      this.input.stepUp(1);
    } else {
      this.input.stepDown(1);
    }
  }
}

export default UpDownNumberInput;
